import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../layout/footer/footer'
import './panel.css'
import Beard from '../../assets/images/logo-beard2.svg'
import { Button, Col, Form, Modal, OverlayTrigger, Popover } from 'react-bootstrap'
import CardNumber from '../inputs/card-number';
import { getUserInfo, getProvince, getCity, getEditUser, getUserCard, getUserCharges, imgBaseUrl, getCharge } from '../../utils/api'
import Loader from '../../components/loader/dotloader'
import { Toast } from 'primereact/toast';
import moment from 'jalali-moment';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import ImgDefult from '../../assets/images/buyed-card.svg';
import Card from '../../assets/icons/card.svg'
import LoaderBtn from '../../components/loader/loader'
import PasswordSection from '../password/changePassword'
import { Sidebar } from 'primereact/sidebar';
import ArrowDown from '../../assets/icons/select-arrow-down.svg'
import Refresh from '../../assets/icons/refresh.svg';
import EditCardComponent from './edit-card/editCard'

//icons
import CardIcon from '../../assets/icons/panel/card.svg'
import Coin from '../../assets/icons/panel/coin.svg'
import Logout from '../../assets/icons/panel/logout.svg'
import Personal from '../../assets/icons/panel/personal.svg'
import Edit from '../../assets/icons/panel/edit.svg'
import ActivePersonal from '../../assets/icons/panel/active/person.svg'
import ActiveCard from '../../assets/icons/panel/active/card.svg'
import ActiveCoin from '../../assets/icons/panel/active/coin.svg'
import Basket from '../../assets/icons/basket.svg'
import { isMobile } from 'react-device-detect';
import useToastNotification from '../../hooks/useToastNotification';
import { useLocation } from "react-router-dom";
import { LoadCanvasTemplate, loadCaptchaEnginge, validateCaptcha, LoadCanvasTemplateNoReload } from 'react-simple-captcha';


function Panel() {
    const toast = useRef(null);
    const location = useLocation();
    const [section, setSection] = useState('info');
    const [showMode, setShowMode] = useState("image");
    const [pageLoading, setPageLoading] = useState(false)
    const [loadingBtn, setLoadingBtn] = useState(false)
    const [chargeLoadingBtn, setChargeLoadingBtn] = useState(false)
    const [userDatas, setUserDatas] = useState(null)
    const [validated, setValidated] = useState(false);
    const [provinceList, setProvinceList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [cards, setCards] = useState([])
    const [charges, setCharges] = useState([])
    const [setting, setSetting] = useState()
    const [passwordSec, setPasswordSec] = useState(false)
    const [toastVisible, setToastVisible] = useState(false);
    //use field
    const [province, setProvince] = useState('');
    const [city, setCity] = useState('');
    const [cityTitle, setCityTilte] = useState(null);
    const [provinceTitle, setProvinceTilte] = useState(null);
    const [genderTitle, setGenderTilte] = useState(null);
    const [birthDate, setBirthDay] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [nationalId, setNationalId] = useState('');
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [gender, setGender] = useState(null);
    const [education, setEducation] = useState('');
    const [jobTitle, setJobTitle] = useState('');
    const [address, setAddress] = useState('');
    const [plate, setPlate] = useState('');
    const [unit, setUnit] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [amountCharge, setAmountCharge] = useState('');
    const [visibleProvince, setVisibleProvince] = useState(false);
    const [visibleCity, setVisibleCity] = useState(false);
    const [part1, setPart1] = useState('6221');
    const [part2, setPart2] = useState('');
    const [part3, setPart3] = useState('');
    const [part4, setPart4] = useState('');
    const [captchaValid, setCaptchaValid] = useState(false);
    const [captchaInput, setCaptchaInput] = useState('');

    const part2Ref = useRef(null);
    const part3Ref = useRef(null);
    const part4Ref = useRef(null);
    const amoutRef = useRef(null);
    const amoutRef1 = useRef(null);
    const part6Ref = useRef(null);
    const part7Ref = useRef(null);
    const part8Ref = useRef(null);


    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const sectionItem = queryParams.get("section");
        console.log(sectionItem)
        setSection(sectionItem)
    }, [])
    const [visibleGender, setVisibleGender] = useState('');
    const GenderList = [{
        id: '',
        title: 'نامشخص'
    }, {
        id: 1,
        title: 'مرد'
    }, {
        id: 2,
        title: 'زن'
    }]
    const handlePart1Change = (e) => {
        setPart1(e.target.value);
        if (e.target.value.length === 4) part2Ref.current.focus();
    };

    const handlePart2Change = (e) => {
        setPart2(e.target.value);
        if (e.target.value.length === 4) part3Ref.current.focus();
        console.log("changed", e.target.value);

    };

    const handlePart3Change = (e) => {
        setPart3(e.target.value);
        if (e.target.value.length === 4) part4Ref.current.focus();
    };

    const handlePart4Change = (e) => {
        console.log(e.target.value.length === 4)
        setPart4(e.target.value);
        if (e.target.value.length === 4) amoutRef1.current.focus();
    };


    const handlePart5Change = (e) => {
        setPart1(e.target.value);
        if (e.target.value.length === 4) part6Ref.current.focus();
    };

    const handlePart6Change = (e) => {
        setPart2(e.target.value);
        if (e.target.value.length === 4) part7Ref.current.focus();
    };

    const handlePart7Change = (e) => {
        setPart3(e.target.value);
        if (e.target.value.length === 4) part8Ref.current.focus();
    };

    const handlePart8Change = (e) => {
        setPart4(e.target.value);
        console.log(e.target.value)
        if (e.target.value.length === 4) amoutRef.current.focus();
    };

    const { showError, showSuccess } = useToastNotification();

    const changeSection = (name) => {
        setSection(name);
    };
    const selectedSectionClassName = "bg-blue flex justify-start text-[white] p-3 rounded-lg cursor-pointer mt-3";
    const unSelectedSectionClassName = "bg-[white] flex justify-start text-blue p-3 rounded-lg cursor-pointer hover:text-[white] hover:bg-blue animation mt-3";

    const copy = async (text) => {
        if (!navigator.clipboard) {
            // Fallback for environments without Clipboard API
            console.warn('Clipboard API is not supported. Using fallback method.');
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed'; // Prevent scrolling to bottom of the page
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                showSuccess('کپی شد!');
            } catch (err) {
                console.error('Fallback copy failed:', err);
            } finally {
                document.body.removeChild(textArea);
            }
            return;
        }

        try {
            await navigator.clipboard.writeText(text);
            console.log('Content copied to clipboard');
            showSuccess('کپی شد!');
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };
    const showToast = (message) => {
        setToastVisible(message);
        setTimeout(() => setToastVisible(false), 2000); // Hide after 2 seconds
    };
    //convert to persianDate
    const convertDateToPersian = (date) => {
        if (!date) return '-';
        return moment(date).locale("fa").format("YYYY/MM/DD");
    };
    const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"]
    const getCities = async (selectedProvince) => {
        try {
            const res = await getCity(selectedProvince); // Assume getCity can take province as argument
            setCityList(res.data.data);
        } catch (error) {
            let message = {
                text: 'خطا در ارتباط با سرور'
            }
            showError(message)
        }

    };

    const getProvinces = async () => {
        setPageLoading(true);
        try {
            const res = await getProvince();
            setProvinceList(res.data.data);
            setPageLoading(false);

        } catch (error) {
            let message = {
                text: 'خطا در ارتباط با سرور'
            }
            showError(message)
            setPageLoading(false);

        }

    };

    const getUserCards = async () => {
        setPageLoading(true);
        try {
            let pay = {
                pageNumber: 0,
                pageSize: 0
            }
            const res = await getUserCard(pay);
            setCards(res.data.data.items);
            setPageLoading(false);

        } catch (error) {
            let message = {
                text: 'خطا در ارتباط با سرور'
            }
            showError(message)
            setPageLoading(false);

        }

    };
    useEffect(() => {
    }, [cards]);
    const getUserChargess = async () => {
        setPageLoading(true);
        try {
            let pay = {
                pageNumber: 0,
                pageSize: 0
            }
            const res = await getUserCharges(pay);
            setCharges(res.data.data.items);
            setPageLoading(false);

        } catch (error) {
            let message = {
                text: 'خطا در ارتباط با سرور'
            }
            showError(message)
            setPageLoading(false);

        }

    };
    useEffect(() => {
    }, [charges]);
    //دریافت اطلاعات کاربر
    const getUserData = async () => {
        setPageLoading(true)
        try {
            let res = await getUserInfo()
            let data = res.data.data
            setUserDatas(res.data.data)
            setFirstName(data.firstName || "");
            setLastName(data.lastName || "");
            setNationalId(data.nationalCode || "");
            // setMobile(data.phone || "");
            setEmail(data.email || "");
            setGender(data.genderId !== null ? data.genderId : 0); //مرد: 1، زن: 2
            setBirthDay(data.birthDate || "");
            setEducation(data.education || "");
            setJobTitle(data.jobTitle || "");
            // provinceList.map(item => {
            //     console.log(item)
            //     if(item.id == data.provinceId){
            //         setProvinceTilte(item.title)
            //     }
            // })
            // cityList.map(item => {
            //     console.log(item)
            //     if(item.id == data.cityId){
            //         setCityTilte(item.title)
            //     }
            // })
            setProvince(data.provinceId || "");
            setCity(data.cityId || "");
            setAddress(data.address || "");
            setPostalCode(data.postalCode || "");
            setPlate(data.plate || "");
            setUnit(data.unit || "");
            setPageLoading(false)
        } catch (error) {
            setPageLoading(false)
            let message = {
                text: 'خطا در ارتباط با سرور'
            }
            showError(message)
        }
    }
    useEffect(() => {
        getUserData()
        getProvinces();
        getUserChargess();
        getUserCards()
        setTimeout(() => {
            let userInfo = JSON.parse(localStorage.getItem('userData'))
            setMobile(userInfo.mobile)
            const set = localStorage.getItem('settings');
            setSetting(JSON.parse(set));
            console.log('inja')
            const screenWidth = window.innerWidth;
            if (screenWidth < 768) { // به عنوان مثال برای موبایل
                const element = document.getElementById('desktop-captcha')
                if (element) {
                    element.remove(); // حذف کامل از DOM
                }
            }

            // loadCaptchaEnginge(6, 'white', 'black', 'numbers','mobile-captcha');

        }, 1000);
    }, []);

    useEffect(() => {

        if (province) {
            if (typeof province === 'object' && Object.keys(province).length > 0) {

                getCities({ provinceId: province.id });
            } else {
                getCities({ provinceId: province });
                provinceList.forEach(item => {
                    if (String(item.id) === String(province)) {
                        setProvinceTilte(item.title);
                    }
                });

            }
        }
    }, [province]); // Fetch cities when province changes

    useEffect(() => {

        if (gender) {

            GenderList.forEach(item => {
                if (String(item.id) === String(gender)) {
                    setGenderTilte(item.title);
                }
            });


        }
    }, [gender]); // Fetch cities when province changes
    useEffect(() => {
        if (city) {

            console.log('././', cityList)
            cityList.forEach(item => {
                if (String(item.id) === String(city)) {
                    setCityTilte(item.title);
                }
            });


        }
    }, [cityList]);
    useEffect(() => {
        if (section === 'charge') {
            console.log('....', section)
            loadCaptchaEnginge(6, 'white', 'black', 'numbers');
        }
    }, [section])

    const logout = () => {
        setLogoutModalShow(true);
    };
    const logoutFromAccount = () => {
        localStorage.removeItem('userData')
        sessionStorage.removeItem('cartItems')
        localStorage.removeItem('token')
        window.location.href = '/'
    };

    // My cards section
    const [myCardsTab, setMyCardsTab] = useState('purchased');
    const changeMyCardsTab = (name) => {
        setMyCardsTab(name);
    };


    const [logoutModalShow, setLogoutModalShow] = React.useState(false);
    const closeLogoutModal = () => {
        setLogoutModalShow(false);
    };

    const [detailsModalShow, setDetailsModalShow] = useState(false);
    const [selectedCard, setSelectedCard] = useState(null);
    const openCardDetailsModal = (item) => {
        setSelectedCard(item);
        setDetailsModalShow(true);
    };
    const closeCardDetailsModal = () => {
        setSelectedCard(null);
        setDetailsModalShow(false);
    };


    const updateUser = async (e) => {
        e.preventDefault();
        debugger
        const form = e.currentTarget;
        if (gender.id == '') {
            let message = {
                text: 'جنسیت را مشخص کنید.'
            }
            showError(message)
            return
        }
        if (form.checkValidity() === true) {
            try {
                setLoadingBtn(true)
                let pay = {
                    address: address,
                    birthDate: birthDate,
                    education: education,
                    email: email,
                    firstName: firstName,
                    genderId: typeof gender === 'object' && Object.keys(gender).length > 0 ? parseInt(gender.id) : parseInt(gender),
                    jobTitle: jobTitle,
                    lastName: lastName,
                    nationalCode: nationalId,
                    phone: mobile,
                    postalCode: postalCode,
                    provinceId: typeof province === 'object' && Object.keys(province).length > 0 ? province.id : province,
                    cityId: typeof city === 'object' && Object.keys(city).length > 0 ? city.id : city,
                }
                let res = await getEditUser(pay)
                if (res.data.isSuccess) {
                    setLoadingBtn(false)
                    let message = {
                        text: 'اطلاعات با موفقیت بروزرسانی شد.'
                    }
                    showSuccess(message)
                } else {
                    let message = {
                        text: res.data.message
                    }
                    showError(message)
                }
            } catch (error) {
                setLoadingBtn(false)
                let message = {
                    text: 'خطا در برقراری با سرور'
                }
                showError(message)
            }
        }
        setValidated(true)
    }
    const cardCharging = async () => {
        setChargeLoadingBtn(true)
        try {
            if (!validateCaptcha(captchaInput.toLowerCase())) {
                // setCaptchaValid(true);
                setCaptchaValid(false);
                let message = {
                    text: 'لطفا کد امنیتی را صحیح وارد کنید.'
                }
                loadCaptchaEnginge(6, 'white', 'black', 'numbers')
                setCaptchaInput('')
                showError(message)
                setChargeLoadingBtn(false)
            } else
                if (parseInt(amountCharge) < setting?.chargeMin || parseInt(amountCharge) > setting?.chargeMax) {
                    let message = {
                        text: `لطفا محدوده قیمتی خود را بین ${parseInt(setting?.chargeMin).toLocaleString()} و ${parseInt(setting?.chargeMax).toLocaleString()} وارد کنید.`
                    }
                    showError(message)
                    setChargeLoadingBtn(false)
                    loadCaptchaEnginge(6, 'white', 'black', 'numbers')
                    setCaptchaInput('')

                } else {
                    let pay = {
                        amount: amountCharge ? parseInt(amountCharge) : 0,
                        cardNumber: part1 + part2 + part3 + part4,
                    }
                    let res = await getCharge(pay)
                    if (res.data.isSuccess) {
                        setChargeLoadingBtn(false)
                        // localStorage.setItem('ChargeOrderId',res.data.data.orderId)
                        window.location.replace(res.data.data.urlRedirect);
                    } else {
                        setChargeLoadingBtn(false)
                        let message = {
                            text: res.data.message
                        }
                        showError(message)
                        loadCaptchaEnginge(6, 'white', 'black', 'numbers')
                        setCaptchaInput('')
                    }
                }

        } catch (error) {
            setChargeLoadingBtn(false)
            let message = {
                text: 'خطا در ارتباط با سرور'
            }
            showError(message)
            loadCaptchaEnginge(6, 'white', 'black', 'numbers')
            setCaptchaInput('')
        }

    }

    const formatAmount = (value) => {
        if (!value) return '';
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add commas as thousand separators
    };

    const handleAmountChange = (input) => {
        const rawValue = input.replace(/,/g, ''); // Remove existing commas
        if (/^\d*$/.test(rawValue)) { // Ensure the value is numeric
            setAmountCharge(rawValue);
        }
    };
    function convertDateToText(input) {
        if (!input) {
            return
        }

        let formatted = input.replace(/&nbsp;/g, ' ');

        // جایگزینی واژه "، " با کامای معمولی
        formatted = formatted.replace(/،/g, ',');

        // حذف فاصله‌های اضافی
        formatted = formatted.trim();

        return formatted;
    }

    const openDialog = () => {
        if (passwordSec) {
            setPasswordSec(false); // ابتدا false شود
            setTimeout(() => {
                setPasswordSec(true); // سپس دوباره true شود
            }, 0); // تغییرات سریع با تایمر کوتاه
        } else {
            setPasswordSec(true)
        }
    }
    useEffect(() => {
    }, [passwordSec]); // Fetch cities when province changes
    useEffect(() => {
    }, [section]); // Fetch cities when province changes
    const toggleSection = (sectionName) => {
        setSection(prevSection => {
            return prevSection === sectionName ? null : sectionName;
        });
    };
    const cardSeparator = (card) => {
        if (card == null || card == '') {
            return ""
        } else {
            const match = card.match(/(\d{4})/g);
            return match ? match.join("-") : ""; // If match is null, return an empty string

        }

    };
    const updateCardNumberViaPaste = (card) => {
        setPart2(card.slice(4, 8));
        setPart3(card.slice(8, 12));
        setPart4(card.slice(12, 16));
    };

    const onCardPaste = (e) => {
        e.preventDefault();
        let value = (e.clipboardData.getData('text'));
        if (!value || value.length !== 16) {
            return;
        }
        try {
            let device = isMobile ? "mobile" : "web";
            for (let index = 2; index <= 4; index++) {
                let input = document.getElementById(`${device}-card-${index}`);
                // input.value = value.slice((index - 1) * 4, index * 4);
                input.innerText = value.slice((index - 1) * 4, index * 4);
            }
            updateCardNumberViaPaste(value);
        } catch (error) {
            console.log(error);
        }
    };


    const [showEditDialog, setShowEditDialog] = useState(false)
    const [cardDetail, setCardDetail] = useState(null)
    const openEditDialog = (item) => {
        console.log(item)
        setCardDetail(item)
        setShowEditDialog(true)
    }
    return (
        <div>
            {
                showEditDialog && (
                    <EditCardComponent item={cardDetail} onClose={() => setShowEditDialog(false)} />
                )
            }
            {toastVisible && (
                <div style={{
                    position: 'fixed',
                    top: '20px',
                    right: '20px',
                    background: '#000000b5',
                    color: '#fff',
                    padding: '10px',
                    borderRadius: '5px',
                    zIndex: 1000,
                }}>
                    {toastVisible}
                </div>
            )}
            {pageLoading && <Loader isLoading={pageLoading} />}
            <Toast ref={toast} />
            <div>
                {passwordSec && <PasswordSection />}
            </div>
            <div className='container web peyment-body profile-body'>
                <div className='d-flex align-items-center title gap-3'><img src={Beard} alt="" />ناحیه کاربری</div>
                <div className='row mt-3 shop-cart gy-5'>
                    <div className='col-md-3 col-sm-12'>
                        <div className={`${section === 'info' ? selectedSectionClassName : unSelectedSectionClassName} font-bold text-base`} onClick={() => changeSection('info')}>
                            <img src={section === 'info' ? ActivePersonal : Personal} alt="" className='mx-2' />اطلاعات کاربری
                        </div>
                        <div className={`${section === 'cards' ? selectedSectionClassName : unSelectedSectionClassName} font-bold text-base`} onClick={() => changeSection('cards')}>
                            <img src={section === 'cards' ? ActiveCard : CardIcon} alt="" className='mx-2' />کارت های من
                        </div>
                        <div className={`${section === 'charge' ? selectedSectionClassName : unSelectedSectionClassName} font-bold text-base`} onClick={() => changeSection('charge')}>
                            <img src={section === 'charge' ? ActiveCoin : Coin} alt="" className='mx-2' />شارژ کارت
                        </div>
                        <div className={unSelectedSectionClassName} onClick={logout}>
                            <img src={Logout} alt="" className='mx-2' />خروج
                        </div>
                    </div>
                    <div className='col-md-9 col-sm-12'>
                        {section === 'info' &&
                            <div className="bg-[#E5ECFF] p-3 rounded-lg item">
                                <Form noValidate validated={validated} onSubmit={(e) => updateUser(e)}>
                                    <div className="row gy-2">


                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>نام <span className='text-[red]'> * </span></Form.Label>
                                                <Form.Control required type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                                <Form.Control.Feedback type="invalid">
                                                    نام را وارد کنید
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>نام خانوادگی <span className='text-[red]'> * </span></Form.Label>
                                                <Form.Control required type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                                <Form.Control.Feedback type="invalid">
                                                    نام خانوادگی را وارد کنید
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text" >
                                                <Form.Label>کد ملی <span className='text-[red]'> * </span></Form.Label>
                                                <Form.Control required className='number' type="number" inputMode="numeric" value={nationalId} onChange={(e) => setNationalId(e.target.value)} />
                                                <Form.Control.Feedback type="invalid">
                                                    کدملی را وارد کنید
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>شماره موبایل <span className='text-[red]'> * </span></Form.Label>
                                                <Form.Control disabled type="number" inputMode="numeric" maxLength="11" value={mobile} onChange={(e) => setMobile(e.target.value)} />

                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>ایمیل</Form.Label>
                                                <Form.Control type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>جنسیت <span className='text-[red]'> * </span></Form.Label>

                                                <Form.Select required value={gender} onChange={(e) => setGender(e.target.value)}>
                                                    <option value="">نامشخص</option>
                                                    <option value="1">مرد</option>
                                                    <option value="2">زن</option>
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    جنسیت را وارد کنید
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group >
                                                <Form.Label style={{ fontWeight: '600' }}>تاریخ تولد</Form.Label>
                                                <DatePicker

                                                    weekDays={weekDays}
                                                    value={birthDate}
                                                    onChange={(date) => setBirthDay(convertDateToPersian(date.toDate()))}
                                                    calendar={persian}
                                                    locale={persian_fa}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    تاریخ تولد را وارد کنید
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>تحصیلات</Form.Label>
                                                <Form.Control type="text" value={education} onChange={(e) => setEducation(e.target.value)} />
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>شغل</Form.Label>
                                                <Form.Control type="text" value={jobTitle} onChange={(e) => setJobTitle(e.target.value)} />
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group>
                                                <Form.Label>استان <span className='text-[red]'> * </span></Form.Label>
                                                <Form.Select required value={province} onChange={(e) => setProvince(e.target.value)}>
                                                    <option value="">انتخاب استان</option>
                                                    {provinceList.length > 0 && provinceList.map(item => (
                                                        <option key={item.id} value={item.id}>{item.title}</option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    استان را وارد کنید
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group>
                                                <Form.Label>شهر <span className='text-[red]'> * </span></Form.Label>
                                                <Form.Select required value={city} onChange={(e) => setCity(e.target.value)}>
                                                    <option value="">انتخاب شهر</option>
                                                    {cityList.length > 0 && cityList.map(item => (
                                                        <option key={item.id} value={item.id}>{item.title}</option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    شهر را وارد کنید
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-8 col-lg-8 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>آدرس</Form.Label>
                                                <Form.Control type="text" value={address} onChange={(e) => setAddress(e.target.value)} />

                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>پلاک</Form.Label>
                                                <Form.Control className='number' type="number" inputMode="numeric" value={plate} onChange={(e) => setPlate(e.target.value)} />
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>واحد</Form.Label>
                                                <Form.Control className='number' type="number" inputMode="numeric" value={unit} onChange={(e) => setUnit(e.target.value)} />
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                           <Form.Group controlId="postalCode">
                                            <Form.Label>
                                                کد پستی <span className='text-[red]'> * </span>
                                            </Form.Label>

                                            <Form.Control
                                                required
                                                className='number'
                                                type="text"
                                                inputMode="numeric"
                                                maxLength={10}
                                                pattern="[0-9]{10}"
                                                value={postalCode}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    // فقط عدد و حداکثر 10 رقم
                                                    if (/^\d{0,10}$/.test(value)) {
                                                        setPostalCode(value);
                                                    }
                                                }}
                                            />

                                            <Form.Control.Feedback type="invalid">
                                                کد پستی باید دقیقا ۱۰ رقم باشد
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        </div>
                                    </div>
                                    <div className='w-100 d-flex align-items-center justify-content-end gap-3'>
                                        <button className='btn btn-primary w-25  text-center mt-4' type='submit' disabled={loadingBtn} style={{ width: 'auto' }}>ثبت {loadingBtn && <LoaderBtn />}</button>
                                        <button className='btn btn-outline-primary w-25  text-center mt-4' type='button' onClick={() => openDialog()} style={{ width: 'auto' }}>رمزعبور دائم</button>

                                    </div>

                                </Form>

                            </div>

                        }

                        {section === 'cards' &&
                            <>

                                {/* <div className="bg-[#E5ECFF] p-3 rounded-lg">
                                        <div className="bg-[#fff] p-3 rounded-lg">
                                            <div className="flex justify-between align-items-center">
                                                <h5 className='font-bold'>کارتی خریداری نشده ...</h5>
                                                <button className='btn btn-primary' type='button'> <img src={require('../../assets/icons/gift.svg').default} alt="" /> خرید کارت هدیه </button>
                                            </div>
                                        </div>
                                    </div>  */}
                                <div className='bg-[#E5ECFF] p-3 rounded-lg mt-3 item' style={{ minHeight: '40vh' }}>

                                    <div className="w-[100%]">
                                        <div className="flex justify-between align-items-center border-b-2 border-blue py-1">
                                            <div className="flex gap-2 font-bold text-blue text-xl">
                                                <div className={'cursor-pointer ' + (myCardsTab !== 'purchased' ? 'text-[#668CFF]' : '')}
                                                    onClick={() => changeMyCardsTab('purchased')}>کارت های خریداری شده</div>
                                                <div className="bg-blue border-r-2 border-blue"></div>
                                                <div className={'cursor-pointer ' + (myCardsTab !== 'charged' ? 'text-[#668CFF]' : '')}
                                                    onClick={() => changeMyCardsTab('charged')}>کارت های شارژ شده</div>
                                            </div>
                                            <div className="">
                                                <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={
                                                    <Popover id="popover-basic" className='border-none'>
                                                        <div className="flex gap-2 p-2 hover:bg-[#0000001f] animation cursor-pointer" onClick={() => setShowMode("list")}>
                                                            <div className='font-bold'>
                                                                لیست
                                                            </div>
                                                            <div>
                                                                <img src={require('../../assets/icons/sort/list.svg').default} alt="" />
                                                            </div>
                                                        </div>
                                                        <div className="flex gap-2 p-2 hover:bg-[#0000001f] animation cursor-pointer" onClick={() => setShowMode("image")}>
                                                            <div className='font-bold'>
                                                                تصویر
                                                            </div>
                                                            <div>
                                                                <img src={require('../../assets/icons/sort/image.svg').default} alt="" />
                                                            </div>
                                                        </div>
                                                    </Popover>
                                                }>
                                                    <button className='bg-[#fff] border-blue border-1 p-1 rounded-md'><img src={require('../../assets/icons/sort/items.svg').default} alt="" /></button>
                                                </OverlayTrigger>
                                            </div>
                                        </div>

                                        {
                                            myCardsTab == 'purchased' &&
                                            <>
                                                {cards && cards.length > 0 ? (

                                                    <div className="mt-3 row gx-4 gy-2">
                                                        {
                                                            cards.map(item => (
                                                                showMode === "image" ?
                                                                    // image mode
                                                                    <div className=" col-sm-12 col-md-6 col-lg-4 " key={item.id}>
                                                                        <div className='card-items'>
                                                                            <div>
                                                                                <div className="relative">
                                                                                    <div className='img-card'>
                                                                                        <img style={{ borderRadius: '8px' }} src={item.imageUrl ? imgBaseUrl + item.imageUrl : ImgDefult} alt="" />
                                                                                    </div>
                                                                                    <div className="card-number flex items-center gap-1 blur-[10] absolute bottom-2 left-2 bg-[#FFFFFFA1] p-1 rounded-xl animation  cursor-pointer"
                                                                                        onClick={() => { copy(item.cardNumber) }}>
                                                                                        <span className="font-bold number"> {cardSeparator(item.cardNumber)} </span>
                                                                                        <img src={require('../../assets/icons/copy.svg').default} className='w-5 h-5' alt="" />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='flex gap-1 items-center p-2 justify-content-between'>
                                                                                <div onClick={() => openCardDetailsModal(item)} className='flex gap-1 items-center p-2 animation  cursor-pointer'>
                                                                                    <img src={require('../../assets/icons/details-blue.svg').default} alt="" />
                                                                                    <div className='font-bold text-sm'>
                                                                                        جزییات بیشتر
                                                                                    </div>
                                                                                </div>
                                                                                {item.isReject && (

                                                                            <div className='cursor-pointer' onClick={() => openEditDialog(item)}><img src={Edit} alt="" /></div>
                                                                            )}

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    // list mode
                                                                    <div className=" col-sm-12 col-md-12 flex border-b-[1px] pb-1" key={item.id}>
                                                                        <div className='max-w-[300px]'>
                                                                            <div className="relative">
                                                                                <div className='img-card w-[270px]'>
                                                                                    <img style={{ borderRadius: '8px' }} src={item.imageUrl ? imgBaseUrl + item.imageUrl : ImgDefult} alt="" />
                                                                                </div>
                                                                                <div className="card-number flex items-center gap-1 blur-[10] absolute bottom-2 left-2 bg-[#FFFFFFA1] p-1 rounded-xl animation  cursor-pointer"
                                                                                    onClick={() => { copy(item.cardNumber) }}>
                                                                                    <span className="font-bold number"> {cardSeparator(item.cardNumber)} </span>
                                                                                    <img src={require('../../assets/icons/copy.svg').default} className='w-5 h-5' alt="" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex flex-col-dir p-2">
                                                                            <Col xs={12} md={6} className='text-sm'>
                                                                                <div className="text-blue font-bold mt-1">
                                                                                    وضعیت : {item?.orderSatus}
                                                                                </div>
                                                                                <div className="font-bold mt-3">
                                                                                    فرستنده: {item?.senderName}
                                                                                </div>
                                                                                <div className="font-bold mt-3 number">
                                                                                    تاریخ سفارش: {convertDateToText(item?.orderDate)}
                                                                                </div>
                                                                                <div className="font-bold mt-3">
                                                                                    گیرنده: {item?.receiverName}
                                                                                </div>
                                                                                <div className="font-bold mt-3 number">
                                                                                    کد پستی: {item?.receiverPotstalCode}
                                                                                </div>
                                                                            </Col>
                                                                            <Col xs={12} md={6} className='text-sm'>
                                                                                <div className="font-bold mt-1 number">
                                                                                    کد سفارش: {item?.orderCode}
                                                                                </div>
                                                                                <div className="font-bold mt-3 number">
                                                                                    شماره تماس: {item?.senderPhone}
                                                                                </div>
                                                                                <div className="font-bold mt-3 number">
                                                                                    تاریخ تحویل: {convertDateToText(item?.deliveredDate)}
                                                                                </div>
                                                                                <div className="font-bold mt-3 number">
                                                                                    تلفن گیرنده: {item?.receiverPhone}
                                                                                </div>
                                                                                <div className="font-bold mt-3">
                                                                                    آدرس: {item?.receiverAddress}
                                                                                </div>
                                                                            </Col>
                                                                        </div>
                                                                               {/* {item.isReject && (

                                                                        <div className='cursor-pointer' onClick={() => openEditDialog(item)}><img src={Edit} alt="" /></div>
                                                                    )} */}
                                                                    </div>
                                                            ))
                                                        }
                                                    </div>
                                                ) :
                                                    (<div className='d-flex align-items-center mt-2 justify-content-between bg-white p-4 m-0 w-100 rounded-lg nocard'>
                                                        <h6 className='text-[#001966] font-bold text-xl nocard-title'>کارتی خریداری نشده ...</h6>
                                                        <button className='btn btn-primary d-flex align-items-center gap-2' type='button' onClick={() => { window.location.href = 'categories' }}>
                                                            <img src={Basket} /> خرید کارت هدیه
                                                        </button>
                                                    </div>)
                                                }
                                            </>

                                        }



                                        {
                                            myCardsTab == 'charged' &&
                                            <>

                                                {charges && charges.length > 0 ? (<div className="mt-3 gx-4 gy-2 row">
                                                    {
                                                        charges.map(item => (
                                                            showMode === "image" ?
                                                                // image mode
                                                                <div className=" col-sm-6 col-md-4 " key={item.id}>
                                                                    <div>
                                                                        <div className="relative">
                                                                            <img style={{ borderRadius: '8px' }} src={item.imageUrl ? imgBaseUrl + item.imageUrl : ImgDefult} alt="" />
                                                                            <div className="card-number flex items-center gap-1 blur-[10] absolute bottom-2 left-2 bg-[#FFFFFFA1] p-1 rounded-xl animation  cursor-pointer"
                                                                                onClick={() => { copy(item.cardNumber) }}>
                                                                                <span className="font-bold number"> {cardSeparator(item.cardNumber)} </span>
                                                                                <img src={require('../../assets/icons/copy.svg').default} className='w-5 h-5' alt="" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {/* <div className='flex gap-1 items-center p-2 justify-content-between'>

                                                                        <div onClick={() => openCardDetailsModal(item)} className='flex gap-1 items-center p-2 animation hover:scale-x-105 cursor-pointer'>
                                                                            <img src={require('../../assets/icons/details-blue.svg').default} alt="" />
                                                                            <div className='font-bold'>
                                                                                جزییات بیشتر
                                                                            </div>
                                                                        </div>
                                                                    </div> */}
                                                                    {/* {item.isReject && (

                                                                        <div className='cursor-pointer' onClick={() => openEditDialog(item)}><img src={Edit} alt="" /></div>
                                                                    )} */}
                                                                </div>
                                                                :
                                                                // list mode
                                                                <div className=" col-sm-12 col-md-12 flex justify-content-between border-b-[1px] pb-1" key={item.id}>
                                                                    <div className='flex'>
                                                                        <div className='max-w-[300px]'>
                                                                            <div className="relative">
                                                                                <img style={{ borderRadius: '8px' }} src={item.imageUrl ? imgBaseUrl + item.imageUrl : ImgDefult} alt="" />
                                                                                <div className="card-number flex items-center gap-1 blur-[10] absolute bottom-2 left-2 bg-[#FFFFFFA1] p-1 rounded-xl animation  cursor-pointer"
                                                                                    onClick={() => { copy(item.cardNumber) }}>
                                                                                    <span className="font-bold number"> {cardSeparator(item.cardNumber)} </span>
                                                                                    <img src={require('../../assets/icons/copy.svg').default} className='w-5 h-5' alt="" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex flex-col-dir p-2">
                                                                            <Col xs={12} md={6} className='text-sm'>
                                                                                <div className="text-blue font-bold mt-1">
                                                                                    وضعیت : {item?.orderSatus}
                                                                                </div>
                                                                                <div className="font-bold mt-3">
                                                                                    فرستنده: {item?.senderName}
                                                                                </div>
                                                                                <div className="font-bold mt-3 number">
                                                                                    تاریخ سفارش: {convertDateToText(item?.orderDate)}
                                                                                </div>
                                                                                <div className="font-bold mt-3">
                                                                                    گیرنده: {item?.receiverName}
                                                                                </div>
                                                                                <div className="font-bold mt-3 number">
                                                                                    کد پستی: {item?.receiverPotstalCode}
                                                                                </div>
                                                                            </Col>
                                                                            <Col xs={12} md={6} className='text-sm'>
                                                                                <div className="font-bold mt-1 number">
                                                                                    کد سفارش: {item?.orderCode}
                                                                                </div>
                                                                                <div className="font-bold mt-3 number">
                                                                                    شماره تماس: {item?.senderPhone}
                                                                                </div>
                                                                                <div className="font-bold mt-3 number">
                                                                                    تاریخ تحویل: {convertDateToText(item?.deliveredDate)}
                                                                                </div>
                                                                                <div className="font-bold mt-3 number">
                                                                                    تلفن گیرنده: {item?.receiverPhone}
                                                                                </div>
                                                                                <div className="font-bold mt-3">
                                                                                    آدرس: {item?.receiverAddress}
                                                                                </div>
                                                                            </Col>
                                                                        </div>
                                                                    </div>
                                                                    {/* {item.isReject && (

                                                                        <div className='cursor-pointer' onClick={() => openEditDialog(item)}><img src={Edit} alt="" /></div>
                                                                    )} */}

                                                                </div>
                                                        ))
                                                    }
                                                </div>
                                                ) : (<div className='d-flex align-items-center mt-2 justify-content-between bg-white p-4 m-0 w-100 rounded-lg nocard'>
                                                    <h6 className='text-[#001966] font-bold text-xl nocard-title'>کارتی خریداری نشده ...</h6>
                                                    <button className='btn btn-primary d-flex align-items-center gap-2' type='button' onClick={() => { window.location.href = 'categories' }}>
                                                        <img src={Basket} /> خرید کارت هدیه
                                                    </button>
                                                </div>)}
                                            </>

                                        }



                                    </div>
                                </div>

                            </>
                        }
                        {section === 'charge' &&
                            <>
                                <div className="bg-[#E5ECFF] p-3 rounded-lg mt-3 item flex-col">
                                    <div className="flex gap-3 flex-wrap w-100">
                                        {/* <div className="flex font-bold flex-1 text-blue justify-center items-center gap-3 bg-[#fff] p-2 rounded-sm flex-1 cursor-pointer hover:scale-105 animation">
                                            <img src={require('../../assets/images/logo/top.svg').default} alt="" />
                                            <div>
                                                شارژ از طریق اپلیکیشن تاپ
                                            </div>
                                        </div> */}
                                        <div className="flex font-bold text-blue justify-center items-center gap-3 bg-[#fff] p-2 rounded-sm flex-1 cursor-pointer animation" onClick={() => { window.location.href = 'https://cafebazaar.ir/app/com.sepas.kadoona' }}>
                                            <img src={require('../../assets/images/logo/kadona.svg').default} alt="" />
                                            <div>
                                                شارژ از طریق اپلیکیشن کادونا
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bg-[#fff] p-2 mt-2 rounded-sm w-full">
                                        <div className="text-[#B8B8B8] border-b-[1px] border-b-[#CCD9FF] text-end p-1 number">تعداد شارژ مجاز باقی مانده برای امروز: {setting?.dailyCardLimit}</div>
                                        <div className="mt-4 flex flex-wrap">
                                            <Col md={6} xs={12}>
                                                <Form.Group controlId="card-number" >
                                                    <Form.Label className='text-sm'> کارت<span className='text-[red]'> * </span></Form.Label>
                                                    <div className="input-icon" style={{ direction: 'ltr' }}>
                                                        <img src={Card} alt="Card Icon" />
                                                        <Form.Control
                                                            type="number"
                                                            readOnly
                                                            inputMode="numeric"
                                                            className="text-center number"
                                                            value={part1}
                                                            onChange={handlePart1Change}
                                                            maxLength="4"
                                                        />{' '}
                                                        -
                                                        <Form.Control
                                                            type="number"
                                                            inputMode="numeric"
                                                            className="text-center number"
                                                            value={part2}
                                                            onChange={handlePart2Change}
                                                            maxLength="4"
                                                            ref={part2Ref}
                                                            onPaste={onCardPaste}
                                                            id="web-card-2"
                                                        />{' '}
                                                        -
                                                        <Form.Control
                                                            type="number"
                                                            inputMode="numeric"
                                                            className="text-center number"
                                                            value={part3}
                                                            onChange={handlePart3Change}
                                                            maxLength="4"
                                                            ref={part3Ref}
                                                            onPaste={onCardPaste}
                                                            id="web-card-3"
                                                        />{' '}
                                                        -
                                                        <Form.Control
                                                            type="number"
                                                            inputMode="numeric"
                                                            className="text-center number"
                                                            value={part4}
                                                            onChange={handlePart4Change}
                                                            maxLength="4"
                                                            ref={part4Ref}
                                                            onPaste={onCardPaste}
                                                            id="web-card-4"
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6} xs={12}>
                                                <Form.Group controlId="text" className="px-2">
                                                    <Form.Label className='text-sm'>مبلغ شارژ<span className='text-[red]'> * </span> (تومان)</Form.Label>
                                                    <Form.Control ref={amoutRef1} className='py-2 number text-right' type="text" value={formatAmount(amountCharge)} // Apply formatting to the displayed value
                                                        onChange={(e) => handleAmountChange(e.target.value)} style={{ direction: 'ltr' }} />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6} xs={12}>
                                                <Form.Group className="mt-3" >
                                                    <Form.Label>کد امنیتی <span className='text-[red]'> * </span></Form.Label>
                                                    <div className="d-flex align-items-center">
                                                        <Form.Control
                                                            value={captchaInput}
                                                            onChange={(e) => setCaptchaInput(e.target.value)}
                                                            placeholder="کد امنیتی را وارد کنید"
                                                        />
                                                        <div className="captcha-container d-flex align-items-center h-[48px] gap-2 ms-2">
                                                            {!isMobile && (
                                                                <div id="desktop-captcha">
                                                                    <LoadCanvasTemplate reload={true} />

                                                                </div>
                                                            )}

                                                            <button
                                                                type="button"
                                                                onClick={() => { loadCaptchaEnginge(6, 'white', 'black', 'numbers'); setCaptchaInput('') }}
                                                                style={{
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    cursor: 'pointer',
                                                                    fontSize: '18px',
                                                                    color: '#007BFF',
                                                                    marginLeft: '10px',
                                                                    width: '18px'
                                                                }}
                                                                title="تولید مجدد کد امنیتی"
                                                            >
                                                                <img src={Refresh} alt="" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                            <div className='w-100 mt-5' style={{ textAlign: '-webkit-left' }}>
                                                <button disabled={chargeLoadingBtn} className='btn btn-primary w-25  text-center mt-5' onClick={() => cardCharging()} style={{ width: 'auto' }}>شارژ کنید {chargeLoadingBtn && <LoaderBtn />}</button>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div >











            <div className='container mobile peyment-body profile-body' style={{ marginBottom: '6em' }}>
                <div className='d-flex align-items-center justify-content-start title gap-3'><img src={Beard} alt="" />ناحیه کاربری</div>
                <div className='row  shop-cart gy-5'>
                    <div className='col-md-3 col-sm-12'>
                        <div
                            className={`${section === 'info' ? selectedSectionClassName : unSelectedSectionClassName} font-bold text-base d-flex justify-content-between flex-row-reverse`}
                            onClick={() => toggleSection('info')}
                        >
                            <img src={section === 'info' ? ActivePersonal : Personal} alt="" className="mx-2" /> اطلاعات کاربری
                        </div>
                        {section === 'info' &&
                            <div className="bg-[#E5ECFF] p-3 rounded-lg item mt-3">
                                <Form noValidate validated={validated} onSubmit={(e) => updateUser(e)}>
                                    <div className="row gy-2">


                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>نام <span className='text-[red]'> * </span></Form.Label>
                                                <Form.Control required type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                                <Form.Control.Feedback type="invalid">
                                                    نام را وارد کنید
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>نام خانوادگی <span className='text-[red]'> * </span></Form.Label>
                                                <Form.Control required type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                                <Form.Control.Feedback type="invalid">
                                                    نام خانوادگی را وارد کنید
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text" >
                                                <Form.Label>کد ملی <span className='text-[red]'> * </span></Form.Label>
                                                <Form.Control required className='number' type="number" inputMode="numeric" value={nationalId} onChange={(e) => setNationalId(e.target.value)} />
                                                <Form.Control.Feedback type="invalid">
                                                    کدملی را وارد کنید
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>شماره موبایل <span className='text-[red]'> * </span></Form.Label>
                                                <Form.Control disabled type="number" inputMode="numeric" value={mobile} onChange={(e) => setMobile(e.target.value)} />

                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>ایمیل</Form.Label>
                                                <Form.Control type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>جنسیت <span className='text-[red]'> * </span></Form.Label>
                                                <div className='mobile'>

                                                    <div className='input-icon '>
                                                        <Form.Control required readOnly value={genderTitle ? genderTitle : ''}
                                                            onClick={(e) => {
                                                                e.preventDefault(); // جلوگیری از باز شدن لیست
                                                                setVisibleGender(true); // نمایش Sidebar
                                                            }} />

                                                        <img src={ArrowDown} alt="" />
                                                    </div>
                                                    <Form.Control.Feedback type="invalid">
                                                        جنسیت را وارد کنید
                                                    </Form.Control.Feedback>
                                                </div>
                                                <Sidebar
                                                    header="جنسیت"
                                                    visible={visibleGender}
                                                    position="bottom"
                                                    onHide={() => setVisibleGender(false)}
                                                >
                                                    <div className="prepared-text-options">
                                                        {GenderList.map((item, index) => (
                                                            <div
                                                                key={index}
                                                                className={`prepared-text-item ${gender === item.id ? 'selected' : ''}`}
                                                                onClick={() => {
                                                                    setGender(item);
                                                                    setGenderTilte(item.title)
                                                                    setVisibleGender(false); // Close sidebar on selection
                                                                }}
                                                                style={{
                                                                    padding: '10px',
                                                                    borderBottom: '1px solid #eee',
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                {item.title}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Sidebar>

                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group >
                                                <Form.Label style={{ fontWeight: '600' }}>تاریخ تولد</Form.Label>
                                                <DatePicker

                                                    weekDays={weekDays}
                                                    value={birthDate}
                                                    onChange={(date) => setBirthDay(convertDateToPersian(date.toDate()))}
                                                    calendar={persian}
                                                    locale={persian_fa}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    تاریخ تولد را وارد کنید
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>تحصیلات</Form.Label>
                                                <Form.Control type="text" value={education} onChange={(e) => setEducation(e.target.value)} />
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>شغل</Form.Label>
                                                <Form.Control type="text" value={jobTitle} onChange={(e) => setJobTitle(e.target.value)} />
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group>
                                                <Form.Label>استان <span className='text-[red]'> * </span></Form.Label>
                                                <div className='mobile'>

                                                    <div className='input-icon '>
                                                        <Form.Control readOnly value={provinceTitle}
                                                            required
                                                            placeholder='انتخاب استان'
                                                            onClick={(e) => {
                                                                e.preventDefault(); // جلوگیری از باز شدن لیست
                                                                setVisibleProvince(true); // نمایش Sidebar
                                                            }} />
                                                        <img src={ArrowDown} alt="" />
                                                    </div>
                                                </div>
                                                <Sidebar
                                                    header="استان"
                                                    visible={visibleProvince}
                                                    position="bottom"
                                                    onHide={() => setVisibleProvince(false)}
                                                >
                                                    <div className="prepared-text-options">
                                                        {provinceList.map((item, index) => (
                                                            <div
                                                                key={index}
                                                                className={`prepared-text-item ${province === item.id ? 'selected' : ''}`}
                                                                onClick={() => {
                                                                    setProvince(item);
                                                                    setProvinceTilte(item.title);
                                                                    setVisibleProvince(false); // Close sidebar on selection
                                                                }}
                                                                style={{
                                                                    padding: '10px',
                                                                    borderBottom: '1px solid #eee',
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                {item.title}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Sidebar>
                                                <Form.Control.Feedback type="invalid">
                                                    استان را وارد کنید
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group>
                                                <Form.Label>شهر <span className='text-[red]'> * </span></Form.Label>
                                                <div className='mobile'>

                                                    <div className='input-icon '>
                                                        <Form.Control readOnly value={cityTitle || city.title}
                                                            placeholder='انتخاب شهر'
                                                            required
                                                            onClick={(e) => {
                                                                e.preventDefault(); // جلوگیری از باز شدن لیست
                                                                setVisibleCity(true); // نمایش Sidebar
                                                            }} />
                                                        <img src={ArrowDown} alt="" />
                                                    </div>
                                                </div>
                                                <Sidebar
                                                    header="شهر"
                                                    visible={visibleCity}
                                                    position="bottom"
                                                    onHide={() => setVisibleCity(false)}
                                                >
                                                    <div className="prepared-text-options">
                                                        {cityList.map((item, index) => (
                                                            <div
                                                                key={index}
                                                                className={`prepared-text-item ${city === item.id ? 'selected' : ''}`}
                                                                onClick={() => {
                                                                    setCity(item);
                                                                    setCityTilte(item.title)
                                                                    setVisibleCity(false); // Close sidebar on selection
                                                                }}
                                                                style={{
                                                                    padding: '10px',
                                                                    borderBottom: '1px solid #eee',
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                {item.title}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Sidebar>
                                                <Form.Control.Feedback type="invalid">
                                                    شهر را وارد کنید
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-8 col-lg-8 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>آدرس</Form.Label>
                                                <Form.Control type="text" value={address} onChange={(e) => setAddress(e.target.value)} />
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>پلاک</Form.Label>
                                                <Form.Control className='number' type="number" inputMode="numeric" value={plate} onChange={(e) => setPlate(e.target.value)} />
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>واحد</Form.Label>
                                                <Form.Control className='number' type="number" inputMode="numeric" value={unit} onChange={(e) => setUnit(e.target.value)} />
                                            </Form.Group>
                                        </div>
                                        <div className='col-md-4 col-lg-4 col-sm-12'>
                                            <Form.Group controlId="text">
                                                <Form.Label>کد پستی<span className='text-[red]'> * </span></Form.Label>
                                                <Form.Control className='number' required type="number" inputMode="numeric" value={postalCode} onChange={(e) => setPostalCode(e.target.value)} />
                                            </Form.Group>
                                        </div>
                                    </div>
                                    <div className='w-100 d-flex align-items-center justify-content-end gap-3'>
                                        <button className='btn btn-primary   text-center mt-4' type='submit' style={{ width: 'auto' }}>ثبت</button>
                                        <button className='btn btn-outline-primary   text-center mt-4' type='button' onClick={() => openDialog()} style={{ width: 'auto' }}>رمزعبور دائم</button>

                                    </div>

                                </Form>

                            </div>

                        }

                        <div className={`${section === 'cards' ? selectedSectionClassName : unSelectedSectionClassName} font-bold text-base d-flex justify-content-between flex-row-reverse`} onClick={() => toggleSection('cards')} >
                            <img src={section === 'cards' ? ActiveCard : CardIcon} alt="" className='mx-2' />کارت های من
                        </div>

                        {section === 'cards' &&
                            <>

                                {/* <div className="bg-[#E5ECFF] p-3 rounded-lg">
                                        <div className="bg-[#fff] p-3 rounded-lg">
                                            <div className="flex justify-between align-items-center">
                                                <h5 className='font-bold'>کارتی خریداری نشده ...</h5>
                                                <button className='btn btn-primary' type='button'> <img src={require('../../assets/icons/gift.svg').default} alt="" /> خرید کارت هدیه </button>
                                            </div>
                                        </div>
                                    </div>  */}
                                <div className='bg-[#E5ECFF] p-3 rounded-lg mt-3 item'>

                                    <div className="w-[100%]">
                                        <div className="flex justify-between align-items-center border-b-2 border-blue py-1">
                                            <div className="flex gap-2 font-bold text-blue text-sm">
                                                <div className={'cursor-pointer ' + (myCardsTab !== 'purchased' ? 'text-[#668CFF]' : '')}
                                                    onClick={() => changeMyCardsTab('purchased')}>کارت های خریداری شده</div>
                                                <div className="bg-blue border-r-2 border-blue"></div>
                                                <div className={'cursor-pointer ' + (myCardsTab !== 'charged' ? 'text-[#668CFF]' : '')}
                                                    onClick={() => changeMyCardsTab('charged')}>کارت های شارژ شده</div>
                                            </div>
                                            <div className="">
                                                <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={
                                                    <Popover id="popover-basic" className='border-none'>
                                                        <div className="flex gap-2 p-2 hover:bg-[#0000001f] animation cursor-pointer" onClick={() => setShowMode("list")}>
                                                            <div className='font-bold'>
                                                                لیست
                                                            </div>
                                                            <div>
                                                                <img src={require('../../assets/icons/sort/list.svg').default} alt="" width={16} />
                                                            </div>
                                                        </div>
                                                        <div className="flex gap-2 p-2 hover:bg-[#0000001f] animation cursor-pointer" onClick={() => setShowMode("image")}>
                                                            <div className='font-bold'>
                                                                تصویر
                                                            </div>
                                                            <div>
                                                                <img src={require('../../assets/icons/sort/image.svg').default} alt="" width={16} />
                                                            </div>
                                                        </div>
                                                    </Popover>
                                                }>
                                                    <button className='bg-[#fff] border-blue border-1 p-1 rounded-md'><img src={require('../../assets/icons/sort/items.svg').default} alt="" width={24} /></button>
                                                </OverlayTrigger>
                                            </div>
                                        </div>

                                        {
                                            myCardsTab == 'purchased' && <>
                                                {cards && cards.length > 0 ? (<div className="mt-3 row gx-4 gy-3">

                                                    {

                                                        cards.map(item => (
                                                            showMode === "image" ?
                                                                // image mode
                                                                <div className=" col-sm-6 col-md-4 " key={item.id}>
                                                                    <div className='card-items'>
                                                                        <div >
                                                                            <div className="relative">
                                                                                <div className='img-card'>
                                                                                    <img style={{ borderRadius: '8px' }} src={item.imageUrl ? imgBaseUrl + item.imageUrl : ImgDefult} alt="" />
                                                                                </div>
                                                                                <div className="card-number flex items-center gap-1 blur-[10] absolute bottom-2 left-2 bg-[#FFFFFFA1] p-1 rounded-xl animation  cursor-pointer"
                                                                                    onClick={() => { copy(item.cardNumber) }}>
                                                                                    <span className="font-bold number"> {cardSeparator(item.cardNumber)} </span>
                                                                                    <img src={require('../../assets/icons/copy.svg').default} className='w-5 h-5' alt="" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div onClick={() => openCardDetailsModal(item)} className='flex gap-1 items-center p-2 animation  cursor-pointer'>
                                                                            <img src={require('../../assets/icons/details-blue.svg').default} alt="" />
                                                                            <div className='font-bold text-sm'>
                                                                                جزییات بیشتر
                                                                            </div>
                                                                        </div>
                                                                        {item.isReject && (
                                                                            <div className='cursor-pointer' onClick={() => openEditDialog(item)} style={{direction: 'ltr'}}><img src={Edit} alt=""  /></div>
                                                                        )}

                                                                    </div>

                                                                </div>
                                                                :
                                                                // list mode
                                                                <div className=" col-sm-12 col-md-12 flex flex-wrap border-b-[1px] pb-1" key={item.id}>
                                                                    <div className='max-w-[300px]'>
                                                                        <div className="relative">
                                                                            <div className='img-card w-[300px] mx-auto'>
                                                                                <img style={{ borderRadius: '8px' }} src={item.imageUrl ? imgBaseUrl + item.imageUrl : ImgDefult} alt="" />
                                                                            </div>
                                                                            <div className="card-number flex items-center gap-1 blur-[10] absolute bottom-2 left-2 bg-[#FFFFFFA1] p-1 rounded-xl animation  cursor-pointer"
                                                                                onClick={() => { copy(item.cardNumber) }}>
                                                                                <span className="font-bold number"> {cardSeparator(item.cardNumber)} </span>
                                                                                <img src={require('../../assets/icons/copy.svg').default} className='w-5 h-5' alt="" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="flex flex-col-dir p-2">
                                                                        <Col xs={12} md={6} className='text-sm'>
                                                                            <div className="text-blue font-bold mt-1">
                                                                                وضعیت : {item?.orderSatus}
                                                                            </div>
                                                                            <div className="font-bold mt-3">
                                                                                فرستنده: {item?.senderName}
                                                                            </div>
                                                                            <div className="font-bold mt-3 number">
                                                                                تاریخ سفارش: {convertDateToText(item?.orderDate)}
                                                                            </div>
                                                                            <div className="font-bold mt-3">
                                                                                گیرنده: {item?.receiverName}
                                                                            </div>
                                                                            <div className="font-bold mt-3 number">
                                                                                کد پستی: {item?.receiverPotstalCode}
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={12} md={6} className='text-sm'>
                                                                            <div className="font-bold mt-1 number">
                                                                                کد سفارش: {item?.orderCode}
                                                                            </div>
                                                                            <div className="font-bold mt-3 number">
                                                                                شماره تماس: {item?.senderPhone}
                                                                            </div>
                                                                            <div className="font-bold mt-3 number">
                                                                                تاریخ تحویل: {convertDateToText(item?.deliveredDate)}
                                                                            </div>
                                                                            <div className="font-bold mt-3 number">
                                                                                تلفن گیرنده: {item?.receiverPhone}
                                                                            </div>
                                                                            <div className="font-bold mt-3">
                                                                                آدرس: {item?.receiverAddress}
                                                                            </div>
                                                                        </Col>
                                                                    </div>
                                                                </div>
                                                        ))

                                                    }




                                                </div>) : (<div className='d-flex mt-2 align-items-center justify-content-between bg-white p-4 m-0 w-100 rounded-lg nocard'>
                                                    <h6 className='text-[#001966] font-bold text-xl nocard-title'>کارتی خریداری نشده ...</h6>
                                                    <button className='btn btn-primary d-flex align-items-center gap-2' type='button' onClick={() => { window.location.href = 'categories' }}>
                                                        <img src={Basket} /> خرید کارت هدیه
                                                    </button>
                                                </div>)}

                                            </>

                                        }


                                        {
                                            myCardsTab == 'charged' &&
                                            <>
                                                {charges && charges.length > 0 ? (<div className="mt-3 gx-4 gy-2 row">
                                                    {

                                                        charges.map(item => (
                                                            showMode === "image" ?
                                                                // image mode
                                                                <div className=" col-sm-6 col-md-4 " key={item.id}>
                                                                    <div>
                                                                        <div className="relative">
                                                                            <img style={{ borderRadius: '8px' }} src={item.imageUrl ? imgBaseUrl + item.imageUrl : ImgDefult} alt="" />
                                                                            <div className="card-number flex items-center gap-1 blur-[10] absolute bottom-2 left-2 bg-[#FFFFFFA1] p-1 rounded-xl animation  cursor-pointer"
                                                                                onClick={() => { copy(item.cardNumber) }}>
                                                                                <span className="font-bold number"> {cardSeparator(item.cardNumber)} </span>
                                                                                <img src={require('../../assets/icons/copy.svg').default} className='w-5 h-5' alt="" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {/* <div onClick={() => openCardDetailsModal(item)} className='flex gap-1 items-center p-2 animation hover:scale-x-105 cursor-pointer'>
                                                                        <img src={require('../../assets/icons/details-blue.svg').default} alt="" />
                                                                        <div className='font-bold'>
                                                                            جزییات بیشتر
                                                                        </div>
                                                                    </div> */}
                                                                </div>
                                                                :
                                                                // list mode
                                                                <div className=" col-sm-12 col-md-12 flex flex-wrap border-b-[1px] pb-1" key={item.id}>
                                                                    <div className='max-w-[300px]'>
                                                                        <div className="relative">
                                                                            <img style={{ borderRadius: '8px' }} src={item.imageUrl ? imgBaseUrl + item.imageUrl : ImgDefult} alt="" />
                                                                            <div className="card-number flex items-center gap-1 blur-[10] absolute bottom-2 left-2 bg-[#FFFFFFA1] p-1 rounded-xl animation cursor-pointer"
                                                                                onClick={() => { copy(item.cardNumber) }}>
                                                                                <span className="font-bold number"> {cardSeparator(item.cardNumber)} </span>
                                                                                <img src={require('../../assets/icons/copy.svg').default} className='w-5 h-5' alt="" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="flex flex-col-dir p-2">
                                                                        <Col xs={12} md={6} className='text-sm'>
                                                                            <div className="text-blue font-bold mt-1">
                                                                                وضعیت : {item?.orderSatus}
                                                                            </div>
                                                                            <div className="font-bold mt-3">
                                                                                فرستنده: {item?.senderName}
                                                                            </div>
                                                                            <div className="font-bold mt-3 number">
                                                                                تاریخ سفارش: {convertDateToText(item?.orderDate)}
                                                                            </div>
                                                                            <div className="font-bold mt-3">
                                                                                گیرنده: {item?.receiverName}
                                                                            </div>
                                                                            <div className="font-bold mt-3 number">
                                                                                کد پستی: {item?.receiverPotstalCode}
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={12} md={6} className='text-sm'>
                                                                            <div className="font-bold mt-1 number">
                                                                                کد سفارش: {item?.orderCode}
                                                                            </div>
                                                                            <div className="font-bold mt-3 number">
                                                                                شماره تماس: {item?.senderPhone}
                                                                            </div>
                                                                            <div className="font-bold mt-3 number">
                                                                                تاریخ تحویل: {convertDateToText(item?.deliveredDate)}
                                                                            </div>
                                                                            <div className="font-bold mt-3 number">
                                                                                تلفن گیرنده: {item?.receiverPhone}
                                                                            </div>
                                                                            <div className="font-bold mt-3">
                                                                                آدرس: {item?.receiverAddress}
                                                                            </div>
                                                                        </Col>
                                                                    </div>
                                                                </div>
                                                        ))
                                                    }



                                                </div>) : (<div className='d-flex mt-2 align-items-center justify-content-between bg-white p-4 m-0 w-100 rounded-lg nocard'>
                                                    <h6 className='text-[#001966] font-bold text-xl nocard-title'>کارتی خریداری نشده ...</h6>
                                                    <button className='btn btn-primary d-flex align-items-center gap-2' type='button' onClick={() => { window.location.href = 'categories' }}>
                                                        <img src={Basket} /> خرید کارت هدیه
                                                    </button>
                                                </div>)}
                                            </>

                                        }



                                    </div>
                                </div>

                            </>
                        }


                        <div className={`${section === 'charge' ? selectedSectionClassName : unSelectedSectionClassName} font-bold text-base d-flex justify-content-between flex-row-reverse`} onClick={() => toggleSection('charge')} >
                            <img src={section === 'charge' ? ActiveCoin : Coin} alt="" className='mx-2' />شارژ کارت
                        </div>
                        {section === 'charge' &&
                            <>
                                <div className="bg-[#E5ECFF] p-3 rounded-lg mt-3 item flex-col">
                                    <div className="flex gap-3  flex-col-dir w-100">
                                        {/* <div className="flex font-bold text-blue justify-center items-center gap-3 bg-[#fff] p-2 rounded-sm flex-1 cursor-pointer hover:scale-105 animation">
                                            <img src={require('../../assets/images/logo/top.svg').default} alt="" />
                                            <div>
                                                شارژ از طریق اپلیکیشن تاپ
                                            </div>
                                        </div> */}
                                        <div className="flex font-bold text-blue justify-center items-center gap-3 bg-[#fff] p-2 rounded-sm flex-1 cursor-pointer  animation">
                                            <img src={require('../../assets/images/logo/kadona.svg').default} alt="" />
                                            <div>
                                                شارژ از طریق اپلیکیشن کادونا
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bg-[#fff] p-2 mt-3 rounded-sm w-full">
                                        <div className="text-[#B8B8B8] border-b-[1px] border-b-[#CCD9FF] text-end p-1 number">تعداد شارژ مجاز باقی مانده برای امروز: {setting?.dailyCardLimit}</div>
                                        <div className="mt-4 flex flex-wrap">
                                            <Col md={6} xs={12}>
                                                <Form.Group controlId="card-mobile-number" >
                                                    <Form.Label className='text-sm'>شماره کارت<span className='text-[red]'> * </span></Form.Label>
                                                    <div className="input-icon" style={{ direction: 'ltr' }}>
                                                        <img src={Card} alt="Card Icon" />
                                                        <Form.Control
                                                            type="number"
                                                            readOnly
                                                            inputMode="numeric"
                                                            className="text-center number"
                                                            value={part1}
                                                            onChange={handlePart5Change}
                                                            maxLength="4"
                                                        />{' '}
                                                        -
                                                        <Form.Control
                                                            type="number"
                                                            inputMode="numeric"
                                                            className="text-center number"
                                                            value={part2}
                                                            onChange={handlePart6Change}
                                                            maxLength="4"
                                                            ref={part6Ref}
                                                            onPaste={onCardPaste}
                                                            id='mobile-card-2'
                                                        />{' '}
                                                        -
                                                        <Form.Control
                                                            type="number"
                                                            inputMode="numeric"
                                                            className="text-center number"
                                                            value={part3}
                                                            onChange={handlePart7Change}
                                                            maxLength="4"
                                                            ref={part7Ref}
                                                            onPaste={onCardPaste}
                                                            id='mobile-card-3'
                                                        />{' '}
                                                        -
                                                        <Form.Control
                                                            type="number"
                                                            inputMode="numeric"
                                                            className="text-center number"
                                                            value={part4}
                                                            onChange={handlePart8Change}
                                                            maxLength="4"
                                                            ref={part8Ref}
                                                            onPaste={onCardPaste}
                                                            id='mobile-card-4'
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6} xs={12}>
                                                <Form.Group controlId="text" className="px-2 mt-3">
                                                    <Form.Label className='text-sm'>مبلغ شارژ<span className='text-[red]'> * </span> (تومان)</Form.Label>
                                                    <Form.Control className='py-2 number text-right' ref={amoutRef} type="number" inputMode="numeric" value={formatAmount(amountCharge)} // Apply formatting to the displayed value
                                                        onChange={(e) => handleAmountChange(e.target.value)} style={{ direction: 'ltr', height: '40px' }} />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6} xs={12}>
                                                <Form.Group className="mt-3">
                                                    <Form.Label>کد امنیتی <span className='text-[red]'> * </span></Form.Label>
                                                    <div className="d-flex align-items-center">
                                                        <Form.Control
                                                            value={captchaInput}
                                                            onChange={(e) => setCaptchaInput(e.target.value)}
                                                            placeholder="کد امنیتی را وارد کنید"
                                                        />
                                                        <div className="captcha-container d-flex align-items-center h-[48px] gap-2 ms-2">
                                                            {isMobile && (
                                                                <div id="mobile-captcha">
                                                                    <LoadCanvasTemplate reload={true} />

                                                                </div>
                                                            )}

                                                            <button
                                                                type="button"
                                                                onClick={() => { loadCaptchaEnginge(6, 'white', 'black', 'numbers'); setCaptchaInput('') }}
                                                                style={{
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    cursor: 'pointer',
                                                                    fontSize: '18px',
                                                                    color: '#007BFF',
                                                                    marginLeft: '10px',
                                                                    width: '18px'
                                                                }}
                                                                title="تولید مجدد کد امنیتی"
                                                            >
                                                                <img src={Refresh} alt="" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                            <div className='w-100 mt-5' style={{ textAlign: '-webkit-left' }}>
                                                <button disabled={chargeLoadingBtn} className='btn btn-primary w-100  text-center mt-2 ' onClick={() => cardCharging()} style={{ width: 'auto' }}>شارژ کنید {chargeLoadingBtn && <LoaderBtn />}</button>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                        <div className={`${unSelectedSectionClassName} font-bold text-base d-flex justify-content-between flex-row-reverse`} onClick={logout}>
                            <img src={Logout} alt="" className='mx-2' />خروج
                        </div>
                    </div>

                </div>
            </div >
            <Modal
                show={logoutModalShow}
                onHide={() => setLogoutModalShow(false)}
                centered
            >
                <Modal.Body className='!p-5'>
                    <div className="flex gap-1 border-b-[#668CFF] border-b-[1px] pb-3">
                        <img src={require('../../assets/icons/danger.svg').default} alt="" />
                        <div className="font-bold text-blue">خروج</div>
                    </div>
                    <div className='font-bold mt-4'>از حساب کاربری خارج می‌شوید؟</div>
                    <div className="flex gap-2 mt-4">
                        <button className='btn btn-outline-primary !border-1 !border-blue flex-1' onClick={closeLogoutModal}>انصراف</button>
                        <button className='btn btn-primary flex-[2]' onClick={() => logoutFromAccount()}>خروج از حساب کاربری</button>
                    </div>
                </Modal.Body>
            </Modal>



            <Modal
                show={detailsModalShow}
                onHide={() => closeCardDetailsModal(false)}
                centered
            >
                <Modal.Body className='!p-5'>
                    <div className="flex justify-between border-b-[#668CFF] border-b-[1px] pb-3">
                        <div className="flex gap-1">
                            <img src={require('../../assets/icons/info.svg').default} alt="" />
                            <div className="font-bold text-blue">جزییات بیشتر</div>
                        </div>
                        <img src={require('../../assets/icons/close.svg').default} className='cursor-pointer animation hover:scale-125' onClick={closeCardDetailsModal} alt="" />
                    </div>
                    <div className="flex flex-col-dir">
                        <Col xs={12} md={6} className='text-sm'>
                            <div className="text-blue font-bold mt-3">
                                وضعیت : {selectedCard?.orderSatus}
                            </div>
                            <div className="font-bold mt-3">
                                فرستنده: {selectedCard?.senderName}
                            </div>
                            <div className="font-bold mt-3 number">
                                تاریخ سفارش: {convertDateToText(selectedCard?.orderDate)}
                            </div>
                            <div className="font-bold mt-3">
                                گیرنده: {selectedCard?.receiverName}
                            </div>
                            <div className="font-bold mt-3 number">
                                کد پستی: {selectedCard?.receiverPotstalCode}
                            </div>
                        </Col>
                        <Col xs={12} md={6} className='text-sm'>
                            <div className="font-bold mt-3 number">
                                کد سفارش: {selectedCard?.orderCode}
                            </div>
                            <div className="font-bold mt-3 number">
                                شماره تماس: {selectedCard?.senderPhone}
                            </div>
                            <div className="font-bold mt-3 number">
                                تاریخ تحویل: {convertDateToText(selectedCard?.deliveredDate)}
                            </div>
                            <div className="font-bold mt-3 number">
                                تلفن گیرنده: {selectedCard?.receiverPhone}
                            </div>
                            <div className="font-bold mt-3">
                                آدرس: {selectedCard?.receiverAddress}
                            </div>
                        </Col>
                    </div>
                </Modal.Body>
            </Modal>
            <div className="home-footer mt-40">
                <Footer />
            </div>
        </div >

    )
}

export default Panel;